export default "__VITE_ASSET__DmpRBAEG__"